import { themeStyle } from "../../components/Components";
import React, { useEffect, useState, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { API_URL, MAIN_TITLE, alertMessage } from "../../actions/auth";
import Paper from "@mui/material/Paper";
import Fab from "@mui/material/Fab";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import PublishIcon from "@mui/icons-material/Publish";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Drawer from "@mui/material/Drawer";
import AddBoxIcon from "@mui/icons-material/AddBox";
import Checkbox from "@mui/material/Checkbox";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonBase from "@mui/material/ButtonBase";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { Category } from "@mui/icons-material";

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const formatToOne = (n) => `${+n.toFixed(1)}`;

function AddFees() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const navigate = useNavigate();
  const [classList, setClassList] = useState([]);
  const [open2, setOpen2] = useState(false);
  const [classs, setClass] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [random, setRandom] = useState("");

  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }

  function getClassList() {
    var classes = Object.keys(classList).map((classs, index) => (
      <MenuItem value={classs}>{classs}</MenuItem>
    ));
    Object.keys(classList).map((classs, index) => (
      console.log(`${classs} ${index}`)
    ));
    return classes;
  }

  function getCategories() {
    var classes = state.auth.studentCategories.map((category, index) => (
      <MenuItem value={category.toUpperCase()}>
        {category.toUpperCase()}
      </MenuItem>
    ));
    return classes;
  }

  function getTotalFees() {
    var tempFeesStructure = JSON.parse(feesStructure2);
    var tempFees =
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory];

    var total = 0;
    for (var i = 0; i < tempFees["expenses"].length; i++) {
      total += parseInt(tempFees["expenses"][i]["amount"]);
    }
    return total;
  }

  function getTotalGst() {
    var tempFeesStructure = JSON.parse(feesStructure2);
    var tempFees =
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory];

    var total = 0;
    for (var i = 0; i < tempFees["expenses"].length; i++) {
      total += parseInt(tempFees["expenses"][i]["gstAmount"]);
    }
    return total;
  }

  function finalize() {
    setIsLoading(true);
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };
    body["user_id"] = state.auth.user.user_id;
    body["institution_id"] = state.auth.user.institution_id;

    axios
      .post(API_URL + "/finalize_fees_structure", body, config)
      .then((res) => {
        setIsLoading(false);
        setOpen2(false);
        window.location.reload(false);
        createAlert("SUCCESS", "Success", "Fees structure finalized.");
      })
      .catch((err) => {
        setIsLoading(false);
        setOpen2(false);
        createAlert(
          "ERROR",
          "Error",
          "Permission Denied / Other errors. Please contact administration.",
        );
      });
  }

  function handleClassChange(e) {
    if (
      !Object.keys(JSON.parse(feesStructure2)[state.auth.currentYear]).includes(
        e.target.value,
      )
    ) {
      var tempFeesStructure = JSON.parse(feesStructure2);
      tempFeesStructure[state.auth.currentYear][e.target.value] = {};
      tempFeesStructure[state.auth.currentYear][e.target.value][
        selectedCategory
      ] = {
        instValue: state.auth.classType == "STANDARDS" ? 3 : 2,
        expenses: [
          {
            name: "Expense",
            amount: "1000",
            gstAmount: "0",
            amountPaid: "0",
            gst: false,
            gstValue: 0,
            manualInst: false,
            installments: Array.apply(
              null,
              Array(state.auth.classType == "STANDARDS" ? 3 : 2),
            ).map((y, i) => {
              return {
                start_date: moment().format("DD-MM-YYYY"),
                end_date: moment().format("DD-MM-YYYY"),
                value: formatToOne(
                  state.auth.classType == "STANDARDS" ? 1000 / 3 : 1000 / 2,
                ),
                paid: false,
                paidLate: false,
                paidDate: null,
                paidDaysLate: 0,
                gstValue: 0,
                gstAmount: "0",
              };
            }),
          },
        ],
        late: {
          enabled: false,
          type: "ONETIME",
          value: "0",
        },
        transactions: [],
        uploads: [],
      };
      setFeesStructure2(JSON.stringify(tempFeesStructure));
    }

    setClass(e.target.value);
  }

  if (state.auth.refresh == "REFRESH_DATA") {
    getData();
    dispatch({ type: "REFRESH_DATA", payload: null });
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getData();
    }
  }, []);

  const [toggleDrawer2, setToggleDrawer2] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feesStructure2, setFeesStructure2] = useState("{}");
  const [extraFees, setExtraFees] = useState("{}");

  const [feesItemIndex, setFeesItemIndex] = useState(9999);
  const [selectedCategory, setSelectedCategory] = useState("GENERAL");

  function addFeesExpense() {
    var tempFeesStructure = JSON.parse(feesStructure2);
    tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
      "expenses"
    ].push({
      name: "Expense",
      amount: "1000",
      gstAmount: "0",
      amountPaid: "0",
      gst: false,
      gstValue: 0,
      manualInst: false,
      installments: Array.apply(
        null,
        Array(
          tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
            "instValue"
          ],
        ),
      ).map((y, i) => {
        return {
          start_date: moment().format("DD-MM-YYYY"),
          end_date: moment().format("DD-MM-YYYY"),
          value: formatToOne(
            state.auth.classType == "STANDARDS" ? 1000 / 3 : 1000 / 2,
          ),
          paid: false,
          paidLate: false,
          paidDate: null,
          paidDaysLate: 0,
          gstValue: 0,
          gstAmount: "0",
        };
      }),
    });
    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function handleLate(value) {
    var tempFeesStructure = JSON.parse(feesStructure2);
    tempFeesStructure[state.auth.currentYear][classs][selectedCategory]["late"][
      "enabled"
    ] = value;

    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function handleLateType(value) {
    var tempFeesStructure = JSON.parse(feesStructure2);
    tempFeesStructure[state.auth.currentYear][classs][selectedCategory]["late"][
      "type"
    ] = value;

    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function handleLateValue(value) {
    var tempFeesStructure = JSON.parse(feesStructure2);
    tempFeesStructure[state.auth.currentYear][classs][selectedCategory]["late"][
      "value"
    ] = value;

    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function handleExtraValue(value, key1, key2) {
    var tempFeesStructure = JSON.parse(extraFees);
    tempFeesStructure[key1][key2] = value;

    setExtraFees(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function handleGst(index, value) {
    var tempFeesStructure = JSON.parse(feesStructure2);
    tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
      "expenses"
    ][index]["gst"] = value;

    if (value) {
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ][index]["gstValue"] = 18;
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ][index]["gstAmount"] = formatToOne(
        parseInt(
          tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
            "expenses"
          ][index]["amount"],
        ) *
          (tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
            "expenses"
          ][index]["gstValue"] /
            100),
      );

      for (
        var i = 0;
        i <
        tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
          "expenses"
        ][index]["installments"].length;
        i++
      ) {
        tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
          "expenses"
        ][index]["installments"][i]["gstAmount"] = formatToOne(
          (parseInt(
            tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
              "expenses"
            ][index]["installments"][i]["value"],
          ) *
            tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
              "expenses"
            ][index]["gstValue"]) /
            100,
        );
      }
    } else {
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ][index]["gstAmount"] = "0";
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ][index]["gstValue"] = 0;

      for (
        var i = 0;
        i <
        tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
          "expenses"
        ][index]["installments"].length;
        i++
      ) {
        tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
          "expenses"
        ][index]["installments"][i]["gstAmount"] = "0";
      }
    }
    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function handleGstValue(index, value) {
    var tempFeesStructure = JSON.parse(feesStructure2);
    if (value != "0") {
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ][index]["gstValue"] = parseInt(value);

      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ][index]["gstAmount"] = formatToOne(
        parseInt(
          tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
            "expenses"
          ][index]["amount"],
        ) *
          (parseInt(value) / 100),
      );

      for (
        var i = 0;
        i <
        tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
          "expenses"
        ][index]["installments"].length;
        i++
      ) {
        tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
          "expenses"
        ][index]["installments"][i]["gstAmount"] = formatToOne(
          (parseInt(
            tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
              "expenses"
            ][index]["installments"][i]["value"],
          ) *
            parseInt(value)) /
            100,
        );
      }
    }

    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function handleManualInst(index, value) {
    var tempFeesStructure = JSON.parse(feesStructure2);
    tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
      "expenses"
    ][index]["manualInst"] = value;

    tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
      "expenses"
    ][index]["installments"] = Array.apply(
      null,
      Array(
        tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
          "instValue"
        ],
      ),
    ).map((y, i) => {
      return {
        start_date: moment().format("DD-MM-YYYY"),
        end_date: moment().format("DD-MM-YYYY"),
        value: formatToOne(
          parseInt(
            tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
              "expenses"
            ][index]["amount"],
          ) /
            tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
              "instValue"
            ],
        ),
        paid: false,
        paidLate: false,
        paidDate: null,
        paidDaysLate: 0,
        gstAmount: tempFeesStructure[state.auth.currentYear][classs][
          selectedCategory
        ]["expenses"][index]["gst"]
          ? formatToOne(
              ((parseInt(
                tempFeesStructure[state.auth.currentYear][classs][
                  selectedCategory
                ]["expenses"][index]["amount"],
              ) /
                tempFeesStructure[state.auth.currentYear][classs][
                  selectedCategory
                ]["instValue"]) *
                tempFeesStructure[state.auth.currentYear][classs][
                  selectedCategory
                ]["expenses"][index]["gstValue"]) /
                100,
            )
          : "0",
      };
    });

    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function handleManualInstValue(index, index2, value) {
    var tempFeesStructure = JSON.parse(feesStructure2);
    tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
      "expenses"
    ][index]["installments"][index2]["value"] = value;
    var newAmount = 0;
    for (
      var i = 0;
      i <
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ][index]["installments"].length;
      i++
    ) {
      newAmount += parseInt(
        tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
          "expenses"
        ][index]["installments"][i]["value"],
      );
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ][index]["installments"][i]["gstAmount"] = formatToOne(
        (parseInt(
          tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
            "expenses"
          ][index]["installments"][i]["value"],
        ) *
          tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
            "expenses"
          ][index]["gstValue"]) /
          100,
      );
    }
    tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
      "expenses"
    ][index]["gstAmount"] = formatToOne(
      newAmount *
        (tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
          "expenses"
        ][index]["gstValue"] /
          100),
    );
    tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
      "expenses"
    ][index]["amount"] = formatToOne(newAmount);
    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function handleInstValue(value) {
    var tempFeesStructure = JSON.parse(feesStructure2);
    tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
      "instValue"
    ] = value;

    for (
      var index = 0;
      index <
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ].length;
      index++
    ) {
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ][index]["installments"] = Array.apply(null, Array(value)).map((y, i) => {
        return {
          start_date: moment().format("DD-MM-YYYY"),
          end_date: moment().format("DD-MM-YYYY"),
          value: formatToOne(
            parseInt(
              tempFeesStructure[state.auth.currentYear][classs][
                selectedCategory
              ]["expenses"][index]["amount"],
            ) / value,
          ),

          paid: false,
          paidLate: false,
          paidDate: null,
          paidDaysLate: 0,
          gstValue: tempFeesStructure[state.auth.currentYear][classs][
            selectedCategory
          ]["expenses"][index]["gst"]
            ? formatToOne(
                ((parseInt(
                  tempFeesStructure[state.auth.currentYear][classs][
                    selectedCategory
                  ]["expenses"][index]["amount"],
                ) /
                  value) *
                  tempFeesStructure[state.auth.currentYear][classs][
                    selectedCategory
                  ]["expenses"][index]["gstValue"]) /
                  100,
              )
            : "0",
        };
      });
    }

    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function handleStartDate(index2, value) {
    var tempFeesStructure = JSON.parse(feesStructure2);

    for (
      var index = 0;
      index <
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ].length;
      index++
    ) {
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ][index]["installments"][index2]["start_date"] =
        moment(value).format("DD-MM-YYYY");
    }

    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function handleEndDate(index2, value) {
    var tempFeesStructure = JSON.parse(feesStructure2);
    for (
      var index = 0;
      index <
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ].length;
      index++
    ) {
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ][index]["installments"][index2]["end_date"] =
        moment(value).format("DD-MM-YYYY");
    }
    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function deleteFeesExpense(index) {
    if (index !== 0) {
      var tempFeesStructure = JSON.parse(feesStructure2);
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ].splice(index, 1);

      setFeesStructure2(JSON.stringify(tempFeesStructure));
      setRandom(makeid(5));
    }
  }

  function editFeesExpense(index, value) {
    var tempFeesStructure = JSON.parse(feesStructure2);
    tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
      "expenses"
    ][index]["name"] = value;
    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function editFeesCost(index, value) {
    var tempFeesStructure = JSON.parse(feesStructure2);
    tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
      "expenses"
    ][index]["amount"] = value;
    if (
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ][index]["gst"]
    ) {
      for (
        var i = 0;
        i <
        tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
          "expenses"
        ][index]["installments"].length;
        i++
      ) {
        tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
          "expenses"
        ][index]["installments"][i]["gstAmount"] = formatToOne(
          ((parseInt(value) /
            tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
              "instValue"
            ]) *
            tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
              "expegstValuenses"
            ][index]["gstValue"]) /
            100,
        );
        tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
          "expenses"
        ][index]["installments"][i]["value"] = formatToOne(
          parseInt(value) /
            tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
              "expenses"
            ][index]["instValue"],
        );
      }

      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ][index]["gstAmount"] = formatToOne(
        parseInt(
          tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
            "expenses"
          ][index]["amount"],
        ) *
          (tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
            "expenses"
          ][index]["gstValue"] /
            100),
      );
    } else {
      tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
        "expenses"
      ][index]["gstAmount"] = "0";

      for (
        var i = 0;
        i <
        tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
          "expenses"
        ][index]["installments"].length;
        i++
      ) {
        tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
          "expenses"
        ][index]["installments"][i]["value"] = formatToOne(
          parseInt(value) /
            tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
              "instValue"
            ],
        );
        tempFeesStructure[state.auth.currentYear][classs][selectedCategory][
          "expenses"
        ][index]["installments"][i]["gstAmount"] = "0";
      }
    }
    setFeesStructure2(JSON.stringify(tempFeesStructure));
    setRandom(makeid(5));
  }

  function addFeesStructure() {
    setIsSubmitting(true);
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;
    body["fees_bracket"] = JSON.parse(feesStructure2);

    axios
      .post(API_URL + "/add_fees_bracket", body, config)
      .then((res) => {
        createAlert("SUCCESS", "Success", "Fees structure added.");
        setIsSubmitting(false);
        getData();
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
        setIsSubmitting(false);
      });
  }

  function getData() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;
    body = JSON.stringify(body);
    axios
      .post(API_URL + "/get_class_list", body, config)
      .then((res) => {
        setClassList(res.data);
        setClass(Object.keys(res.data)[0]);
        var clas = Object.keys(res.data)[0];
        axios
          .post(API_URL + "/get_fees_structure", body, config)
          .then((res) => {
            setExtraFees(JSON.stringify(res.data["extra_fees"]));
            if (JSON.stringify(res.data["fees_structure"]) == "{}") {
              var currentYear = state.auth.currentYear;
              var tempFeesStructure = {};
              tempFeesStructure[currentYear] = {};
              tempFeesStructure[currentYear][clas] = {};
              tempFeesStructure[currentYear][clas][selectedCategory] = {
                instValue: state.auth.classType == "STANDARDS" ? 3 : 2,
                expenses: [
                  {
                    name: "Expense",
                    amount: "1000",
                    gstAmount: "0",
                    amountPaid: "0",
                    gst: false,
                    gstValue: 0,
                    manualInst: false,
                    installments: Array.apply(
                      null,
                      Array(state.auth.classType == "STANDARDS" ? 3 : 2),
                    ).map((y, i) => {
                      return {
                        start_date: moment().format("DD-MM-YYYY"),
                        end_date: moment().format("DD-MM-YYYY"),
                        value: formatToOne(
                          state.auth.classType == "STANDARDS"
                            ? 1000 / 3
                            : 1000 / 2,
                        ),
                        paid: false,
                        paidLate: false,
                        paidDate: null,
                        paidDaysLate: 0,
                        gstValue: 0,
                        gstAmount: "0",
                      };
                    }),
                  },
                ],
                late: {
                  enabled: false,
                  type: "ONETIME",
                  value: "0",
                },

                transactions: [],
                uploads: [],
              };
              setFeesStructure2(JSON.stringify(tempFeesStructure));
              setRandom(makeid(5));
            } else {
              setFeesStructure2(JSON.stringify(res.data["fees_structure"]));
            }
            setIsLoading(false);
          });
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });
  }

  function getContent() {
    return (
      <div style={{ width: "100vw", fontSize: "18px", paddingBottom: "200px" }}>
        <h2>Fees Brackets by Category</h2>
        <div style={{ marginTop: "-15px" }}>
          {!state.auth.finalized && (
            <h4>To change the values, press edit icon (pencil) on the right</h4>
          )}
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #aaa",
            paddingBottom: "15px",
            marginBottom: "15px",
          }}
        >
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={3}>
              <Select
                value={selectedCategory}
                onChange={(e) => {
                  if (
                    !Object.keys(
                      JSON.parse(feesStructure2)[state.auth.currentYear][
                        classs
                      ],
                    ).includes(e.target.value)
                  ) {
                    var tempFeesStructure = JSON.parse(feesStructure2);
                    tempFeesStructure[state.auth.currentYear][classs][
                      e.target.value
                    ] = {
                      instValue: state.auth.classType == "STANDARDS" ? 3 : 2,
                      expenses: [
                        {
                          name: "Expense",
                          amount: "1000",
                          gstAmount: "0",
                          amountPaid: "0",
                          gst: false,
                          gstValue: 0,
                          manualInst: false,
                          installments: Array.apply(
                            null,
                            Array(state.auth.classType == "STANDARDS" ? 3 : 2),
                          ).map((y, i) => {
                            return {
                              start_date: moment().format("DD-MM-YYYY"),
                              end_date: moment().format("DD-MM-YYYY"),
                              value: formatToOne(
                                state.auth.classType == "STANDARDS"
                                  ? 1000 / 3
                                  : 1000 / 2,
                              ),
                              paid: false,
                              paidLate: false,
                              paidDate: null,
                              paidDaysLate: 0,
                              gstValue: 0,
                              gstAmount: "0",
                            };
                          }),
                        },
                      ],
                      late: {
                        enabled: false,
                        type: "ONETIME",
                        value: "0",
                      },
                      transactions: [],
                      uploads: [],
                    };
                    setFeesStructure2(JSON.stringify(tempFeesStructure));
                  }

                  setSelectedCategory(e.target.value);
                }}
                style={{
                  marginTop: "-5px",
                  height: "40px",
                  marginBottom: "5px",
                }}
                fullWidth
                variant={"outlined"}
              >
                {getCategories()}
              </Select>
            </Grid>

            <Grid item xs={3}>
              <Select
                value={classs}
                onChange={(e) => handleClassChange(e)}
                style={{
                  marginTop: "-5px",
                  height: "400px",
                  marginBottom: "5px",
                }}
                fullWidth
                variant={"outlined"}
              >
                {getClassList()}
              </Select>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            justifyContent={"flex-end"}
            alignItems="center"
          >
            <Grid item xs={4}>
              Number of{" "}
              {state.auth.classType == "STANDARDS" ? "terms" : "semesters"} per
              year:
            </Grid>

            <Grid item xs={2}>
              <Select
                value={
                  JSON.parse(feesStructure2)[state.auth.currentYear][classs][
                    selectedCategory
                  ]["instValue"]
                }
                onChange={(e) => handleInstValue(e.target.value)}
                style={{
                  height: "40px",
                  marginTop: "2px",
                  marginLeft: "10px",
                }}
                fullWidth
                variant={"outlined"}
              >
                <MenuItem value={2}>{2}</MenuItem>
                <MenuItem value={3}>{3}</MenuItem>
                <MenuItem value={4}>{4}</MenuItem>
              </Select>
            </Grid>
          </Grid>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-end",
            borderBottom: "1px solid #aaa",
            paddingBottom: "15px",
            marginBottom: "15px",
          }}
        >
          {Array.apply(
            null,
            Array(
              JSON.parse(feesStructure2)[state.auth.currentYear][classs][
                selectedCategory
              ]["instValue"],
            ),
          ).map((installment, index2) => (
            <div
              style={{
                display: "flex",
                height: "100px",
              }}
            >
              <div style={{ marginRight: "15px", marginTop: "30px" }}>
                Term {index2 + 1} Fees Collection period
              </div>
              <div style={{ marginRight: "15px" }}>
                <div style={{ fontSize: "15px" }}>Start Date</div>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    inputFormat="dd-MM-yyyy"
                    value={moment(
                      JSON.parse(feesStructure2)[state.auth.currentYear][
                        classs
                      ][selectedCategory]["expenses"][0]["installments"][
                        index2
                      ]["start_date"],
                      "DD-MM-YYYY",
                    ).toDate()}
                    sx={{
                      height: "35px",
                      width: "100%",
                    }}
                    onChange={(date) => handleStartDate(index2, date)}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        style={{
                          width: "100%",

                          height: "40px",
                        }}
                        size="small"
                        fullWidth
                        {...params}
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
              <div>
                <div style={{ fontSize: "15px" }}>End Date</div>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    inputFormat="dd-MM-yyyy"
                    value={moment(
                      JSON.parse(feesStructure2)[state.auth.currentYear][
                        classs
                      ][selectedCategory]["expenses"][0]["installments"][
                        index2
                      ]["end_date"],
                      "DD-MM-YYYY",
                    ).toDate()}
                    sx={{
                      height: "35px",
                      width: "100%",
                    }}
                    onChange={(date) => handleEndDate(index2, date)}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        style={{
                          width: "100%",

                          height: "40px",
                        }}
                        size="small"
                        fullWidth
                        {...params}
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
            </div>
          ))}
        </div>

        {feesStructure2 != "{}" ? (
          <div
            style={{
              marginTop: "30px",
              border: "3px solid " + themeStyle.primaryCardColor,
              borderRadius: "15px",
              padding: "15px",
            }}
          >
            <Grid
              container
              spacing={2}
              style={{
                justifyContent: "flex-start",
                textAlign: "left",
                paddingBottom: "15px",
                color: themeStyle.primaryColor,
                borderBottom: "1px solid" + themeStyle.primaryColor,
                backgroundColor: themeStyle.primaryCardColor,
                width: "101.2%",
                borderTopRightRadius: "15px",
                borderTopLeftRadius: "15px",
              }}
            >
              <Grid item md={2}>
                Fee Type
              </Grid>
              {state.auth.classType == "SEMESTERS" && (
                <Grid item md={1.5}>
                  GST
                </Grid>
              )}
              <Grid item md={state.auth.classType == "STANDARDS" ? 3 : 1.5}>
                Amount
              </Grid>
              <Grid item md={5}>
                Installments
              </Grid>
              <Grid item md={1.5}>
                Options
              </Grid>
            </Grid>
            {Object.keys(
              JSON.parse(feesStructure2)[state.auth.currentYear][classs][
                selectedCategory
              ]["expenses"],
            ).map((fees, index) => (
              <Grid
                container
                style={{
                  color: "black",
                  padding: "15px",
                  alignItems: "center",
                  paddingTop: "23px",
                  alignItems: "flex-start",
                }}
              >
                <Grid item md={2}>
                  {feesItemIndex == index ? (
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Expense"
                      variant="outlined"
                      value={
                        JSON.parse(feesStructure2)[state.auth.currentYear][
                          classs
                        ][selectedCategory]["expenses"][index]["name"]
                      }
                      style={{ width: "90%" }}
                      onChange={(e) => editFeesExpense(index, e.target.value)}
                    />
                  ) : (
                    <div>
                      <h3 style={{ marginTop: "5px" }}>
                        {
                          JSON.parse(feesStructure2)[state.auth.currentYear][
                            classs
                          ][selectedCategory]["expenses"][index]["name"]
                        }
                      </h3>
                    </div>
                  )}
                </Grid>
                {state.auth.classType == "SEMESTERS" && (
                  <Grid item md={1.5}>
                    <div style={{ display: "flex" }}>
                      <Checkbox
                        labelStyle={{
                          color:
                            feesItemIndex == index
                              ? themeStyle.primaryColor
                              : "grey",
                        }}
                        iconStyle={{ fill: "white" }}
                        checked={
                          JSON.parse(feesStructure2)[state.auth.currentYear][
                            classs
                          ][selectedCategory]["expenses"][fees]["gst"]
                        }
                        onChange={(e) => {
                          if (feesItemIndex == index) {
                            handleGst(index, e.target.checked);
                          }
                        }}
                        value={1}
                        style={{
                          color:
                            feesItemIndex == index
                              ? themeStyle.primaryColor
                              : "grey",
                        }}
                      />
                      {feesItemIndex == index ? (
                        <div style={{ marginTop: "9px" }}>GST?</div>
                      ) : (
                        ""
                      )}
                      {feesItemIndex != index ? (
                        <div style={{ marginTop: "9px" }}>
                          {JSON.parse(feesStructure2)[state.auth.currentYear][
                            classs
                          ][selectedCategory]["expenses"][fees]["gst"]
                            ? JSON.parse(feesStructure2)[
                                state.auth.currentYear
                              ][classs][selectedCategory]["expenses"][fees][
                                "gstValue"
                              ] + "% GST"
                            : "GST"}
                        </div>
                      ) : (
                        <div>
                          {JSON.parse(feesStructure2)[state.auth.currentYear][
                            classs
                          ][selectedCategory]["expenses"][fees]["gst"] ? (
                            <TextField
                              style={{
                                marginLeft: "10px",
                                width: "70%",
                                marginTop: "2px",
                              }}
                              size="small"
                              placeholder="Cost"
                              variant="outlined"
                              type="number"
                              value={
                                JSON.parse(feesStructure2)[
                                  state.auth.currentYear
                                ][classs][selectedCategory]["expenses"][fees][
                                  "gstValue"
                                ]
                              }
                              onChange={(e) =>
                                handleGstValue(index, e.target.value)
                              }
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    </div>
                  </Grid>
                )}
                <Grid item md={state.auth.classType == "STANDARDS" ? 3 : 1.5}>
                  {feesItemIndex == index ? (
                    <div>
                      <TextField
                        style={{
                          width: "80%",
                          marginBottom: "40px",
                        }}
                        size="small"
                        placeholder="Cost"
                        variant="outlined"
                        type="number"
                        value={
                          JSON.parse(feesStructure2)[state.auth.currentYear][
                            classs
                          ][selectedCategory]["expenses"][fees]["amount"]
                        }
                        onChange={(e) => {
                          if (e.target.value == null) {
                            editFeesCost(index, "1");
                          } else {
                            editFeesCost(index, e.target.value);
                          }
                        }}
                      />
                      {JSON.parse(feesStructure2)[state.auth.currentYear][
                        classs
                      ][selectedCategory]["expenses"][fees]["gst"] && (
                        <div
                          style={{
                            fontSize: "14px",
                            marginTop: "-40px",
                            marginBottom: "20px",
                          }}
                        >
                          +GST:{" "}
                          {formatToOne(
                            (parseInt(
                              JSON.parse(feesStructure2)[
                                state.auth.currentYear
                              ][classs][selectedCategory]["expenses"][fees][
                                "amount"
                              ],
                            ) *
                              JSON.parse(feesStructure2)[
                                state.auth.currentYear
                              ][classs][selectedCategory]["expenses"][fees][
                                "gstValue"
                              ]) /
                              100,
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ width: "80%", marginBottom: "15px" }}>
                      <h3
                        style={{
                          marginLeft: "20px",
                          marginTop: "5px",
                          display: "flex",
                        }}
                      >
                        &#8377;&nbsp;&nbsp;
                        {
                          JSON.parse(feesStructure2)[state.auth.currentYear][
                            classs
                          ][selectedCategory]["expenses"][fees]["amount"]
                        }
                      </h3>
                      {JSON.parse(feesStructure2)[state.auth.currentYear][
                        classs
                      ][selectedCategory]["expenses"][fees]["gst"] && (
                        <div
                          style={{
                            marginLeft: "10px",
                            fontSize: "14px",
                            marginTop: "-20px",
                          }}
                        >
                          +GST:{" "}
                          {formatToOne(
                            (parseInt(
                              JSON.parse(feesStructure2)[
                                state.auth.currentYear
                              ][classs][selectedCategory]["expenses"][fees][
                                "amount"
                              ],
                            ) *
                              JSON.parse(feesStructure2)[
                                state.auth.currentYear
                              ][classs][selectedCategory]["expenses"][fees][
                                "gstValue"
                              ]) /
                              100,
                          )}
                        </div>
                      )}
                    </div>
                  )}
                  {feesItemIndex == index &&
                  JSON.parse(feesStructure2)[state.auth.currentYear][classs][
                    selectedCategory
                  ]["expenses"][fees]["manualInst"] ? (
                    <div
                      style={{
                        marginTop: "-25px",
                      }}
                    >
                      {JSON.parse(feesStructure2)[state.auth.currentYear][
                        classs
                      ][selectedCategory]["expenses"][fees]["installments"].map(
                        (instal, index0) => (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              flexDirection: "column",
                              justifyContent: "center",
                              height: "55px",
                              marginBottom: "15px",
                            }}
                          >
                            <TextField
                              style={{
                                width: "80%",
                                marginTop: "20px",
                              }}
                              size="small"
                              placeholder="Cost"
                              variant="outlined"
                              type="number"
                              value={
                                JSON.parse(feesStructure2)[
                                  state.auth.currentYear
                                ][classs][selectedCategory]["expenses"][fees][
                                  "installments"
                                ][index0]["value"]
                              }
                              onChange={(e) =>
                                handleManualInstValue(
                                  index,
                                  index0,
                                  e.target.value,
                                )
                              }
                            />
                            {JSON.parse(feesStructure2)[state.auth.currentYear][
                              classs
                            ][selectedCategory]["expenses"][fees]["gst"] && (
                              <div
                                style={{
                                  marginTop: "10px",
                                  fontSize: "14px",
                                  marginTop: "2px",
                                }}
                              >
                                +GST:{" "}
                                {formatToOne(
                                  (JSON.parse(feesStructure2)[
                                    state.auth.currentYear
                                  ][classs][selectedCategory]["expenses"][fees][
                                    "installments"
                                  ][index0]["value"] *
                                    JSON.parse(feesStructure2)[
                                      state.auth.currentYear
                                    ][classs][selectedCategory]["expenses"][
                                      fees
                                    ]["gstValue"]) /
                                    100,
                                )}
                              </div>
                            )}
                          </div>
                        ),
                      )}
                    </div>
                  ) : (
                    <div style={{ width: "80%", marginTop: "-15px" }}>
                      {JSON.parse(feesStructure2)[state.auth.currentYear][
                        classs
                      ][selectedCategory]["expenses"][fees]["manualInst"] ? (
                        <div
                          style={{
                            marginTop: JSON.parse(feesStructure2)[
                              state.auth.currentYear
                            ][classs][selectedCategory]["expenses"][fees]["gst"]
                              ? "20px"
                              : "40px",
                          }}
                        >
                          {JSON.parse(feesStructure2)[state.auth.currentYear][
                            classs
                          ][selectedCategory]["expenses"][fees][
                            "installments"
                          ].map((instal, index0) => (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                flexDirection: "column",
                                justifyContent: "center",
                                height: "62px",
                                marginLeft: "20px",
                                display: "flex",
                                marginBottom: "5px",
                              }}
                            >
                              &#8377;&nbsp;&nbsp;
                              {
                                JSON.parse(feesStructure2)[
                                  state.auth.currentYear
                                ][classs][selectedCategory]["expenses"][fees][
                                  "installments"
                                ][index0]["value"]
                              }
                              {JSON.parse(feesStructure2)[
                                state.auth.currentYear
                              ][classs][selectedCategory]["expenses"][fees][
                                "gst"
                              ] && (
                                <div
                                  style={{
                                    marginTop: "-5px",
                                    fontSize: "14px",
                                  }}
                                >
                                  +GST:{" "}
                                  {formatToOne(
                                    (JSON.parse(feesStructure2)[
                                      state.auth.currentYear
                                    ][classs][selectedCategory]["expenses"][
                                      fees
                                    ]["installments"][index0]["value"] *
                                      JSON.parse(feesStructure2)[
                                        state.auth.currentYear
                                      ][classs][selectedCategory]["expenses"][
                                        fees
                                      ]["gstValue"]) /
                                      100,
                                  )}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                </Grid>
                <Grid item md={5}>
                  <div style={{ display: "flex" }}>
                    {feesItemIndex != index ? (
                      <div style={{ marginTop: "15px" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div style={{ marginLeft: "35px" }}>
                            {!JSON.parse(feesStructure2)[
                              state.auth.currentYear
                            ][classs][selectedCategory]["expenses"][fees][
                              "manualInst"
                            ] ? (
                              <div
                                style={{ width: "250px", marginTop: "-15px" }}
                              >
                                &#8377;
                                {formatToOne(
                                  parseInt(
                                    JSON.parse(feesStructure2)[
                                      state.auth.currentYear
                                    ][classs][selectedCategory]["expenses"][
                                      fees
                                    ]["amount"],
                                  ) /
                                    JSON.parse(feesStructure2)[
                                      state.auth.currentYear
                                    ][classs][selectedCategory]["instValue"],
                                ) + " Per Inst."}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: "-15px",
                            }}
                          >
                            <Checkbox
                              labelStyle={{
                                color:
                                  feesItemIndex == index
                                    ? themeStyle.primaryColor
                                    : "grey",
                              }}
                              iconStyle={{ fill: "white" }}
                              checked={
                                JSON.parse(feesStructure2)[
                                  state.auth.currentYear
                                ][classs][selectedCategory]["expenses"][fees][
                                  "manualInst"
                                ]
                              }
                              onChange={(e) => {
                                if (feesItemIndex == index) {
                                  handleManualInst(index, e.target.checked);
                                }
                              }}
                              value={1}
                              style={{
                                color:
                                  feesItemIndex == index
                                    ? themeStyle.primaryColor
                                    : "grey",
                              }}
                            />
                            {JSON.parse(feesStructure2)[state.auth.currentYear][
                              classs
                            ][selectedCategory]["expenses"][fees][
                              "manualInst"
                            ] ? (
                              <div>Manual Installments</div>
                            ) : (
                              <div>Manual Installments?</div>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div style={{ display: "flex" }}>
                        <div style={{ marginLeft: "35px", marginTop: "10px" }}>
                          {!JSON.parse(feesStructure2)[state.auth.currentYear][
                            classs
                          ][selectedCategory]["expenses"][fees][
                            "manualInst"
                          ] ? (
                            <div style={{ width: "250px" }}>
                              <div style={{ width: "100%" }}>
                                &#8377;
                                {formatToOne(
                                  parseInt(
                                    JSON.parse(feesStructure2)[
                                      state.auth.currentYear
                                    ][classs][selectedCategory]["expenses"][
                                      fees
                                    ]["amount"],
                                  ) /
                                    JSON.parse(feesStructure2)[
                                      state.auth.currentYear
                                    ][classs][selectedCategory]["instValue"],
                                ) + " Per Inst."}
                              </div>
                              {JSON.parse(feesStructure2)[
                                state.auth.currentYear
                              ][classs][selectedCategory]["expenses"][fees][
                                "gst"
                              ] && (
                                <div>
                                  &#8377;
                                  {formatToOne(
                                    ((parseInt(
                                      JSON.parse(feesStructure2)[
                                        state.auth.currentYear
                                      ][classs][selectedCategory]["expenses"][
                                        fees
                                      ]["amount"],
                                    ) /
                                      JSON.parse(feesStructure2)[
                                        state.auth.currentYear
                                      ][classs][selectedCategory][
                                        "instValue"
                                      ]) *
                                      JSON.parse(feesStructure2)[
                                        state.auth.currentYear
                                      ][classs][selectedCategory]["expenses"][
                                        index
                                      ]["gstValue"]) /
                                      100,
                                  )}
                                  &nbsp; +GST Per Inst.
                                </div>
                              )}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>

                        <div style={{ display: "flex" }}>
                          <Checkbox
                            labelStyle={{
                              color:
                                feesItemIndex == index
                                  ? themeStyle.primaryColor
                                  : "grey",
                            }}
                            iconStyle={{ fill: "white" }}
                            checked={
                              JSON.parse(feesStructure2)[
                                state.auth.currentYear
                              ][classs][selectedCategory]["expenses"][fees][
                                "manualInst"
                              ]
                            }
                            onChange={(e) => {
                              if (feesItemIndex == index) {
                                handleManualInst(index, e.target.checked);
                              }
                            }}
                            value={1}
                            style={{
                              color:
                                feesItemIndex == index
                                  ? themeStyle.primaryColor
                                  : "grey",
                              marginTop:
                                JSON.parse(feesStructure2)[
                                  state.auth.currentYear
                                ][classs][selectedCategory]["expenses"][fees][
                                  "gst"
                                ] &&
                                !JSON.parse(feesStructure2)[
                                  state.auth.currentYear
                                ][classs][selectedCategory]["expenses"][fees][
                                  "manualInst"
                                ]
                                  ? "-20px"
                                  : "0px",
                            }}
                          />
                          {JSON.parse(feesStructure2)[state.auth.currentYear][
                            classs
                          ][selectedCategory]["expenses"][fees][
                            "manualInst"
                          ] ? (
                            <div style={{ marginTop: "9px", width: "300px" }}>
                              Manual Installments
                            </div>
                          ) : (
                            <div style={{ marginTop: "9px", width: "300px" }}>
                              Manual Installments?
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  {JSON.parse(feesStructure2)[state.auth.currentYear][classs][
                    selectedCategory
                  ]["expenses"][fees]["manualInst"] ? (
                    <div style={{ marginTop: "15px" }}>
                      {JSON.parse(feesStructure2)[state.auth.currentYear][
                        classs
                      ][selectedCategory]["expenses"][fees]["installments"].map(
                        (installment, index3) => (
                          <div
                            style={{
                              height: "70px",
                              width: "100%",
                              paddingTop: JSON.parse(feesStructure2)[
                                state.auth.currentYear
                              ][classs][selectedCategory]["expenses"][fees][
                                "gst"
                              ]
                                ? "12px"
                                : "20px",
                              paddingLeft: "55px",
                            }}
                          >
                            For Term {index3 + 1} Fees
                          </div>
                        ),
                      )}
                    </div>
                  ) : (
                    <div></div>
                  )}
                </Grid>

                <Grid item md={1.5}>
                  {!state.auth.finalized && (
                    <div
                      style={{
                        display: "flex",
                        marginLeft: "30px",
                        justifyContent: "center",
                      }}
                    >
                      {feesItemIndex == index ? (
                        <Button
                          onClick={() => setFeesItemIndex(9999)}
                          style={{ borderRadius: "20px" }}
                        >
                          <SaveIcon />
                        </Button>
                      ) : (
                        <Button
                          onClick={() => setFeesItemIndex(index)}
                          style={{ borderRadius: "20px" }}
                        >
                          <EditIcon />
                        </Button>
                      )}

                      <Button
                        onClick={() => deleteFeesExpense(index)}
                        style={{ borderRadius: "20px" }}
                      >
                        <DeleteIcon style={{ color: "#ff3333" }} />
                      </Button>
                    </div>
                  )}
                </Grid>
              </Grid>
            ))}
          </div>
        ) : (
          ""
        )}
        <div
          style={{
            width: "30%",
          }}
        >
          {Object.keys(JSON.parse(extraFees)).map((extra, exIndex) => (
            <div style={{ marginLeft: "15px" }}>
              <br />
              <div style={{ fontWeight: "bold" }}>{extra}</div>
              <hr />
              {Object.keys(JSON.parse(extraFees)[extra]).map(
                (extra2, exIndex2) => (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      marginBottom: "5px",
                    }}
                  >
                    <div>{extra2}</div>
                    <TextField
                      size="small"
                      placeholder="Expense"
                      variant="outlined"
                      value={JSON.parse(extraFees)[extra][extra2]}
                      style={{ marginLeft: "15px" }}
                      onChange={(e) => {
                        handleExtraValue(e.target.value, extra, extra2);
                      }}
                    />
                  </div>
                ),
              )}
            </div>
          ))}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Checkbox
              labelStyle={{
                color: themeStyle.primaryColor,
              }}
              iconStyle={{ fill: "white" }}
              checked={
                JSON.parse(feesStructure2)[state.auth.currentYear][classs][
                  selectedCategory
                ]["late"]["enabled"]
              }
              onChange={(e) => {
                handleLate(e.target.checked);
              }}
              value={1}
              style={{
                color: themeStyle.primaryColor,
              }}
            />
            <div style={{ width: "400px" }}>Late Fees:</div>
            <Select
              value={
                JSON.parse(feesStructure2)[state.auth.currentYear][classs][
                  selectedCategory
                ]["late"]["type"]
              }
              onChange={(e) => handleLateType(e.target.value)}
              style={{
                height: "40px",
                marginTop: "2px",
              }}
              fullWidth
              variant={"outlined"}
            >
              <MenuItem value={"ONETIME"}>{"ONETIME"}</MenuItem>
              <MenuItem value={"DAILY"}>{"DAILY"}</MenuItem>
              <MenuItem value={"WEEKLY"}>{"WEEKLY"}</MenuItem>
              <MenuItem value={"MONTHLY"}>{"MONTHLY"}</MenuItem>
            </Select>{" "}
            <TextField
              fullWidth
              size="small"
              placeholder="Expense"
              variant="outlined"
              value={
                JSON.parse(feesStructure2)[state.auth.currentYear][classs][
                  selectedCategory
                ]["late"]["value"]
              }
              style={{ marginLeft: "15px" }}
              onChange={(e) => {
                handleLateValue(e.target.value);
              }}
            />
          </div>
          <div
            style={{
              marginTop: "15px",
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              flexDirection: "column",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ width: "150px" }}>Sub Total:</div>
              <div
                style={{
                  width: "150px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {getTotalFees()}
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ width: "150px" }}>Total GST:</div>{" "}
              <div
                style={{
                  width: "150px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {getTotalGst()}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "10px",
                paddingTop: "5px",
                borderTop: "2px solid grey",
              }}
            >
              <div style={{ width: "150px", fontWeight: "bold" }}>
                Grand Total:
              </div>
              <div
                style={{
                  width: "150px",
                  display: "flex",
                  justifyContent: "flex-end",
                  fontWeight: "bold",
                }}
              >
                {getTotalFees() + getTotalGst()}
              </div>
            </div>
          </div>
        </div>

        {!state.auth.finalized && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "30px",
            }}
          >
            <Fab
              size="small"
              style={{
                boxShadow: "none",
                backgroundColor: themeStyle.primaryColor,
              }}
              onClick={() => addFeesExpense()}
              aria-label="add"
            >
              <AddIcon
                style={{
                  color: "white",
                }}
              />
            </Fab>
          </div>
        )}
      </div>
    );
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_billing) {
        if (isLoading) {
          return (
            <Fragment>
              <Sidebar />
              <div
                style={{
                  maxWidth: "88vw",
                  marginTop: "45vh",
                  marginLeft: "8vw",
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            </Fragment>
          );
        } else {
          return (
            <Fragment>
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open2}
                onClose={() => setOpen2(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open2}>
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      backgroundColor: "white",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 400,
                      padding: "20px",
                      borderRadius: "15px",
                    }}
                  >
                    <div style={{ marginTop: "-25px" }}>
                      <div
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <h3>Finalize this fees structure?</h3>
                        <IconButton size="small">
                          <CloseIcon
                            onClick={() => setOpen2(false)}
                            style={{ color: themeStyle.primaryColor }}
                          />
                        </IconButton>
                      </div>

                      <span>
                        This action cannot be reversed. It will be finalized and
                        cannot be changed till next year .
                      </span>
                      <br></br>
                      <br></br>
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          onClick={() => finalize()}
                          style={{ height: "30px" }}
                          variant="contained"
                        >
                          Yes
                        </Button>
                        <Button
                          style={{ height: "30px", marginLeft: "10px" }}
                          variant="contained"
                          onClick={() => setOpen2(false)}
                        >
                          No
                        </Button>
                      </div>
                    </div>
                  </div>
                </Fade>
              </Modal>
              <Drawer
                anchor={"right"}
                open={toggleDrawer2}
                onClose={() => setToggleDrawer2(false)}
              >
                <div
                  style={{
                    padding: "15px",
                    width: "30vw",
                    marginTop: "23px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      marginTop: "45px",
                      color: themeStyle.primaryColor,
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    Summary
                  </div>
                  <br />

                  <div style={{ display: "flex", width: "100%" }}>
                    <div style={{ width: "25%" }}>Year:</div>{" "}
                    {state.auth.currentYear}
                  </div>
                  <br />
                  <div style={{ display: "flex", width: "100%" }}>
                    <div style={{ width: "25%" }}>Class:</div> {classs}
                  </div>
                  <br />
                  <div style={{ display: "flex", width: "100%" }}>
                    <div style={{ width: "25%" }}>Category:</div>{" "}
                    {selectedCategory}
                  </div>
                  <br />
                  <div style={{ display: "flex", width: "100%" }}>
                    <div style={{ width: "25%" }}>Expenses:</div>{" "}
                    <div>
                      {JSON.parse(feesStructure2)[state.auth.currentYear][
                        classs
                      ][selectedCategory]["expenses"].map((expense, index) => (
                        <div style={{ marginBottom: "25px" }}>
                          <div>
                            {index +
                              1 +
                              ". " +
                              expense["name"] +
                              " " +
                              expense["amount"] +
                              " yearly"}
                          </div>

                          {state.auth.classType == "SEMESTERS" && (
                            <div style={{ marginTop: "5px" }}>
                              GST:{" "}
                              {expense["gst"]
                                ? expense["gstValue"] + "% Applicable"
                                : "Not applicable"}
                            </div>
                          )}
                          <div style={{ marginTop: "5px" }}>
                            {JSON.parse(feesStructure2)[state.auth.currentYear][
                              classs
                            ][selectedCategory]["instValue"] + " Installments"}
                          </div>

                          <div style={{ marginTop: "5px" }}>
                            &#8377;
                            {formatToOne(
                              parseInt(expense["amount"]) /
                                JSON.parse(feesStructure2)[
                                  state.auth.currentYear
                                ][classs][selectedCategory]["instValue"],
                            ) + " Per Inst."}
                          </div>

                          <div>
                            {expense["installments"].map((instal, index2) => (
                              <div>
                                &nbsp; &nbsp; &nbsp;
                                {index2 +
                                  1 +
                                  ". From " +
                                  instal["start_date"] +
                                  " to " +
                                  instal["end_date"]}
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div style={{ width: "25%" }}>Late Fees:</div>
                    <div>
                      {state.auth.classType == "SEMESTERS" && (
                        <div>
                          {JSON.parse(feesStructure2)[state.auth.currentYear][
                            classs
                          ][selectedCategory]["late"]["enabled"]
                            ? "Applicable"
                            : "Not Applicable"}
                        </div>
                      )}
                      {JSON.parse(feesStructure2)[state.auth.currentYear][
                        classs
                      ][selectedCategory]["late"]["enabled"] ? (
                        <div>
                          {
                            JSON.parse(feesStructure2)[state.auth.currentYear][
                              classs
                            ][selectedCategory]["late"]["value"]
                          }
                        </div>
                      ) : (
                        ""
                      )}
                      {JSON.parse(feesStructure2)[state.auth.currentYear][
                        classs
                      ][selectedCategory]["late"]["enabled"] ? (
                        <div>
                          {
                            JSON.parse(feesStructure2)[state.auth.currentYear][
                              classs
                            ][selectedCategory]["late"]["type"]
                          }
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <br></br>

                  <div
                    style={{
                      marginTop: "15px",
                      color: themeStyle.primaryColor,
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    Fees Breakdown
                  </div>
                  {JSON.parse(feesStructure2)[state.auth.currentYear][classs][
                    selectedCategory
                  ]["expenses"].map((fees, index) => (
                    <div style={{ width: "100%" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            fontSize: 18,
                            color: "black",
                          }}
                        >
                          {fees["name"]}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          <div
                            style={{
                              fontSize: 18,
                              color: "black",
                            }}
                          >
                            &#8377; {fees["amount"]}
                          </div>
                        </div>
                      </div>
                      {fees["gst"] ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              fontSize: 18,
                              color: "grey",
                            }}
                          >
                            GST
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <div
                              style={{
                                fontSize: 18,
                                color: "grey",
                              }}
                            >
                              &#8377; {fees["gstAmount"]}
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <div
                        style={{
                          height: 10,
                        }}
                      ></div>
                      {fees["installments"].length != 0 ? (
                        <div>
                          {fees["installments"].map((fees2, index2) => (
                            <div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  width: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: 16,
                                    color: themeStyle.primaryColor,
                                  }}
                                >
                                  Inst. {index2 + 1}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: 16,
                                      color: themeStyle.primaryColor,
                                    }}
                                  >
                                    &#8377; {fees2["value"]}
                                  </div>
                                </div>
                              </div>
                              {fees["gst"] ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: 16,
                                      color: "grey",
                                    }}
                                  >
                                    GST for Inst. {index2 + 1}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: 16,
                                        color: "grey",
                                      }}
                                    >
                                      &#8377; {fees2["gstAmount"]}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}

                              <div
                                style={{
                                  height: 10,
                                }}
                              ></div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ))}
                  <div
                    style={{
                      marginTop: "15px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                      flexDirection: "column",
                      marginTop: "10px",
                      paddingTop: "5px",
                      borderTop: "2px solid " + themeStyle.primaryColor,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <div style={{ width: "100%" }}>
                        {state.auth.classType == "SEMESTERS" ? "Sub" : ""}{" "}
                        Total:
                      </div>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        {getTotalFees()}
                      </div>
                    </div>
                    {state.auth.classType == "SEMESTERS" && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <div style={{ width: "100%" }}>Total GST:</div>{" "}
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          {getTotalGst()}
                        </div>
                      </div>
                    )}
                    {state.auth.classType == "SEMESTERS" && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "10px",
                          paddingTop: "5px",
                          borderTop: "2px solid grey",
                          width: "100%",
                        }}
                      >
                        <div style={{ width: "100%", fontWeight: "bold" }}>
                          Grand Total:
                        </div>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-end",
                            fontWeight: "bold",
                          }}
                        >
                          {getTotalFees() + getTotalGst()}
                        </div>
                      </div>
                    )}
                  </div>
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      height: "35px",
                      marginTop: "45px",
                    }}
                  >
                    <Button
                      onClick={() => addFeesStructure()}
                      fullWidth
                      variant="contained"
                      style={{
                        backgroundColor: themeStyle.primaryColor,
                        boxShadow: "none",
                      }}
                    >
                      <h4>Add Fees Structure</h4>
                    </Button>
                  </Box>
                </div>
              </Drawer>

              {!state.auth.finalized && (
                <div
                  style={{
                    height: "50px",
                    width: "225px",
                    padding: "5px 10px",
                    borderRadius: "50px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "none",
                    backgroundColor: themeStyle.primaryColor,
                    position: "fixed",
                    bottom: 30,
                    right: 30,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    var tempFeesStructure = JSON.parse(feesStructure2);
                    var allGood = true;
                    for (
                      var i = 0;
                      i <
                      tempFeesStructure[state.auth.currentYear][classs][
                        selectedCategory
                      ]["expenses"].length;
                      i++
                    ) {
                      for (
                        var j = 0;
                        j <
                        tempFeesStructure[state.auth.currentYear][classs][
                          selectedCategory
                        ]["expenses"][i]["installments"].length;
                        j++
                      ) {
                        if (
                          !moment(
                            tempFeesStructure[state.auth.currentYear][classs][
                              selectedCategory
                            ]["expenses"][i]["installments"][j]["start_date"],
                            "DD-MM-YYYY",
                          ).isBefore(
                            moment(
                              tempFeesStructure[state.auth.currentYear][classs][
                                selectedCategory
                              ]["expenses"][i]["installments"][j]["end_date"],
                              "DD-MM-YYYY",
                            ),
                          )
                        ) {
                          allGood = false;
                          createAlert(
                            "ERROR",
                            "Date Error in Installment " + (j + 1),
                            "Start Date should be before end date in the installment for (" +
                              tempFeesStructure[state.auth.currentYear][classs][
                                selectedCategory
                              ]["expenses"][i]["name"] +
                              ", inst " +
                              (j + 1) +
                              ")",
                          );
                          break;
                        }

                        if (j != 0) {
                          if (
                            moment(
                              tempFeesStructure[state.auth.currentYear][classs][
                                selectedCategory
                              ]["expenses"][i]["installments"][j]["start_date"],
                              "DD-MM-YYYY",
                            ).isAfter(
                              moment(
                                tempFeesStructure[state.auth.currentYear][
                                  classs
                                ][selectedCategory]["expenses"][i][
                                  "installments"
                                ][j - 1]["end_date"],
                                "DD-MM-YYYY",
                              ),
                            )
                          ) {
                            continue;
                          } else {
                            allGood = false;
                            createAlert(
                              "ERROR",
                              "Date Error in installments " +
                                j +
                                " and " +
                                (j + 1),
                              "Start Date of installment " +
                                (j + 1) +
                                " should be after end date of installment " +
                                j,
                            );
                            break;
                          }
                        }
                      }
                    }
                    if (allGood) {
                      setToggleDrawer2(true);
                    }
                  }}
                  aria-label="add"
                >
                  <AddBoxIcon
                    style={{
                      color: "white",
                      marginRight: "15px",
                      fontSize: "30px",
                    }}
                  />
                  <div
                    style={{
                      color: "white",
                      fontSize: "18px",
                      fontWeight: "bold",
                    }}
                  >
                    Save Structure
                  </div>
                </div>
              )}
              <Sidebar
                tabs={
                  <div>
                    {!state.auth.finalized && (
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <div
                          style={{
                            height: "40px",
                            width: "325px",
                            padding: "5px 10px",
                            borderRadius: "15px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            boxShadow: "none",
                            backgroundColor: themeStyle.primaryColor,
                            cursor: "pointer",
                          }}
                          onClick={() => setOpen2(true)}
                          aria-label="add"
                        >
                          <div
                            style={{
                              color: "white",
                              fontSize: "20px",
                              fontWeight: "bold",
                            }}
                          >
                            FINALIZE FEES STRUCTURE
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                }
              />
              <div
                style={{
                  borderRadius: "15px",
                  margin: "38px 40px 20px 90px",
                  backgroundColor: "white",
                  display: "flex",
                }}
              >
                {getContent()}
              </div>
            </Fragment>
          );
        }
      } else {
        createAlert("ERROR", "Permission Denied.", "Please Login as Student");
        dispatch({
          type: "AUTH_ERROR",
        });
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          borderRadius: "15px",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default AddFees;
